(function () {
  'use strict';

  /* The alerts variable contains an array of alerts. Each alert should have a text and type property.
   * Optionally, a timeout property can be specified for each alert, otherwise the default of 5 seconds is used
   * unless the permanent property is included and set to true */
  angular.module('wsLrs.directives').directive('wsAlerts', ['$timeout', function wsAlerts($timeout) {
    return {
      restrict: 'AE',
      replace: false,
      scope: {
        alerts: "="
      },
      templateUrl: "modules/common/directives/alerts/alerts.html",
      link: function link($scope) {
        var defaultTimeout = 5000;
        $scope.$watchCollection('alerts', function (newValue, oldValue) {
          var newAlerts = _.difference(newValue, oldValue);
          angular.forEach(newAlerts, function (alert) {
            if (!alert.permanent) {
              alert.timeout = alert.timeout || defaultTimeout;
              $timeout(function () {
                $scope.alerts.splice($scope.alerts.indexOf(alert), 1);
              }, alert.timeout);
            }
          });
        });
        $scope.closeAlert = function closeAlert(index) {
          $scope.alerts.splice(index, 1);
        };
      }
    };
  }]);
})();
